import React from "react";
import { Box, Flex, Image, Text, Link } from "@chakra-ui/react";
import NexusLogo from "../images/logo_nexus_consult.png";

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="white"
      borderTop="1px solid"
      borderColor="gray.200"
      py={4}
      mt="auto"
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="center"
        gap={3}
        maxW={{ base: "100%", lg: "1400px" }}
        mx="auto"
        px={{ base: 4, md: 6 }}
      >
        <Link
          href="https://www.nexusconsultoriams.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s"
        >
          <Image
            src={NexusLogo}
            alt="Nexus Consultoria Logo"
            maxH={{ base: "30px", md: "40px" }}
            objectFit="contain"
          />
        </Link>
      </Flex>
    </Box>
  );
};

export default Footer;
